module.exports = __webpack_public_path__ + "static/media/icon.602fd9c5.png";